import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {OSNotificationData} from "../payloads/os-notification-data";

@Injectable({
  providedIn: 'root'
})
export class OSNotificationService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  checkNotificationPermission(): void {
    if (!this.isBrowser) {
      return;
    }

    if (!('Notification' in window)) {
      console.warn("Notifications not supported!");
    }
  }

  showNotification(notificationData: OSNotificationData): void {
    if (!this.isBrowser || !('Notification' in window)) {
      return;
    }

    const notification = new Notification(
      notificationData.title,
      {
        body: notificationData.body,
        icon: notificationData.icon,
        requireInteraction: true,
        dir: "auto"
      }
    );

    const audio = new Audio('assets/medias/mixkit-bell-notification-933.mp3');
    audio.play();

    notification.onclick = () => {
      window.open(notificationData.url, '_blank');
      notification.close();
    };
  }

}
